import template from './template.html';
import { extend } from 'lodash';


export default {
    name: 'modal',
    template: template,
    props: {
        canClose: {
            default: true,
            type: Boolean,
        },
    },

    methods: {
        close() {
            if ( this.canClose ) {
                this.$root.modal = false;
                this.$emit('close');
            }
        },
    },

    mounted() {
        this.$root.modal = true;
        this.$refs.modal.focus();
        this.$nextTick(() => {
            this.$refs.modal.blur();
        });
    },
};
